import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=f0187c44&scoped=true&"
import script from "./Announcement.vue?vue&type=script&lang=js&"
export * from "./Announcement.vue?vue&type=script&lang=js&"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=f0187c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0187c44",
  null
  
)

export default component.exports